import { Form } from 'antd';
import { CreateAdministratorInput } from 'src/shared/types/api';
import { FormProps } from '.';
import { ContactDetailsFormItems } from './items';

export type CreateAdministratorForm = CreateAdministratorInput;

export const AdministratorModalForm = ({
  form,
}: FormProps<CreateAdministratorForm>) => (
  <Form form={form} layout="vertical">
    <ContactDetailsFormItems emailRequired phoneNumberRequired />
  </Form>
);
